{
  "source": "legacy/cdm2026_v2.html",
  "poisson": {
    "baseTotalGoals": 2.45,
    "totalGoalsEloDivisor": 500,
    "lambdaMin": 0.18,
    "shareEloDivisor": 235,
    "maxGoalsPerTeam": 7,
    "formulaNote": "dr = (eloA+homeBonusA) - (eloB+homeBonusB) ; total attendu t = base + |dr|/totalGoalsEloDivisor ; lambdaA = max(lambdaMin, (t + dr/shareEloDivisor)/2) ; lambdaB = max(lambdaMin, (t - dr/shareEloDivisor)/2)."
  },
  "homeAdvantageElo": {
    "legacyModel": 90,
    "legacyModelKo": 90,
    "eloUpdate": 100,
    "note": "Legacy (mapping Poisson + pwin) : +90, hôtes dans leur pays. Mise à jour Elo officielle (specs/03) : +100 eloratings.net. Les deux constantes coexistent volontairement."
  },
  "winProbEloDivisor": 400,
  "monteCarloRuns": 20000,
  "preTournamentTitleProbs": {
    "ESP": 25.8,
    "ARG": 18.1,
    "FRA": 11.9,
    "ENG": 7.6,
    "POR": 5,
    "BRA": 4.8,
    "COL": 4.3,
    "ECU": 2.6,
    "NED": 2.4,
    "GER": 2.3,
    "NOR": 1.8,
    "SUI": 1.6,
    "CRO": 1.6,
    "TUR": 1.3,
    "URU": 1.3,
    "USA": 1,
    "SEN": 0.9,
    "JPN": 0.9,
    "MAR": 0.8,
    "CAN": 0.8,
    "BEL": 0.8,
    "MEX": 0.4,
    "AUT": 0.4,
    "SCO": 0.2
  },
  "preTournamentTitleProbsNote": "Pourcentages du Monte Carlo pré-tournoi du legacy (équipes < 0,3 % absentes). Sert de référence aux deltas du dashboard.",
  "shootout": {
    "model": "gk",
    "gkRatingDivisor": 100,
    "fallbackModel": "fiftyFifty",
    "note": "Décision utilisateur 13/06/2026 : vainqueur des TAB tiré selon la qualité des gardiens — P(domicile) = 1/(1+10^(-(gkH-gkA)/100)), soit ~56 % pour 10 pts d'écart EA FC 26, ~61 % pour 20 pts (effet volontairement modéré, les études UEFA 2025 ne trouvant pas d'avantage systématique). Équipe sans rating gardien => 50/50."
  },
  "legacyNotes": [
    "Le legacy ne simule pas de prolongation : score tiré sur le match entier, égalité => TAB direct.",
    "TAB legacy : vainqueur tiré avec la probabilité Elo pwin. Nouveau moteur : prolongation lambda/3 puis TAB selon gardiens (fallback 50/50).",
    "Départage ultime des classements legacy : Elo décroissant (pas de tirage au sort seedé)."
  ]
}
